/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Accessible_MotionInputs */

const en_a11y_statement_accessible_motion = /** @type {(inputs: A11y_Statement_Accessible_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motion reduction (respects system settings and manual toggle)`)
};

const de_a11y_statement_accessible_motion = /** @type {(inputs: A11y_Statement_Accessible_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewegungsreduzierung (respektiert Systemeinstellung und manueller Schalter)`)
};

const fr_a11y_statement_accessible_motion = /** @type {(inputs: A11y_Statement_Accessible_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduction du mouvement (respecte les parametres systeme et le bouton manuel)`)
};

const es_a11y_statement_accessible_motion = /** @type {(inputs: A11y_Statement_Accessible_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduccion de movimiento (respeta configuracion del sistema y boton manual)`)
};

const it_a11y_statement_accessible_motion = /** @type {(inputs: A11y_Statement_Accessible_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riduzione del movimento (rispetta le impostazioni di sistema e il pulsante manuale)`)
};

const nl_a11y_statement_accessible_motion = /** @type {(inputs: A11y_Statement_Accessible_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewegingsreductie (respecteert systeeminstellingen en handmatige schakelaar)`)
};

const pl_a11y_statement_accessible_motion = /** @type {(inputs: A11y_Statement_Accessible_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redukcja ruchu (respektuje ustawienia systemowe i reczny przelacznik)`)
};

const fi_a11y_statement_accessible_motion = /** @type {(inputs: A11y_Statement_Accessible_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liikevahennyss (kunnioittaa järjestelmäasetuksia ja manuaalista kytkintä)`)
};

const da_a11y_statement_accessible_motion = /** @type {(inputs: A11y_Statement_Accessible_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevaegelsesreduktion (respekterer systemindstillinger og manuel skift)`)
};

const sv_a11y_statement_accessible_motion = /** @type {(inputs: A11y_Statement_Accessible_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rorelsereduktion (respekterar systeminstellningar och manuell vaxling)`)
};

/**
* | output |
* | --- |
* | "Motion reduction (respects system settings and manual toggle)" |
*
* @param {A11y_Statement_Accessible_MotionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_accessible_motion = /** @type {((inputs?: A11y_Statement_Accessible_MotionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Accessible_MotionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_accessible_motion(inputs)
	if (locale === "fr") return fr_a11y_statement_accessible_motion(inputs)
	if (locale === "es") return es_a11y_statement_accessible_motion(inputs)
	if (locale === "it") return it_a11y_statement_accessible_motion(inputs)
	if (locale === "nl") return nl_a11y_statement_accessible_motion(inputs)
	if (locale === "pl") return pl_a11y_statement_accessible_motion(inputs)
	if (locale === "fi") return fi_a11y_statement_accessible_motion(inputs)
	if (locale === "da") return da_a11y_statement_accessible_motion(inputs)
	if (locale === "sv") return sv_a11y_statement_accessible_motion(inputs)
	return en_a11y_statement_accessible_motion(inputs)
});